@if (!editMode) {
  <div [style.background]="color" [style.padding]="'5px'">
    {{ color }}
  </div>
} @else {
  <span [formGroup]="formGroup">
    <input
      [style.background]="color"
      (colorPickerClose)="changeColor($event)"
      [(colorPicker)]="color"
      [value]="color"
      [cpPosition]="'left'" />
  </span>
}
